// Phase 13a — Notification read shapes (admin endpoints land in 13e; this
// file ships the read shape only so OpenAPI + typed-client work the
// moment Phase 14 reads land).
//
// Per 13a-1: Notification.status is a two-state roll-up (QUEUED |
// COMPLETED). Detailed lifecycle lives on NotificationDelivery rows.
//
// Per 13-E: NotificationChannel was EMAIL-only at v1; doc 14 (SMS-7) adds
// SMS as the first additional channel (v1.x). IN_APP / PUSH follow with the
// mobile apps.
//
// Per 13-D: NotificationCategory drives the suppression model — hard
// bounces suppress all categories; spam complaints suppress MARKETING
// only.
import { z } from 'zod';
// ─────────────────────────────────────────────────────────────────────────────
// Enums (mirror Prisma's notifications enums)
// ─────────────────────────────────────────────────────────────────────────────
export const NotificationChannelSchema = z.enum(['EMAIL', 'SMS']);
export const NotificationCategorySchema = z.enum([
    'TRANSACTIONAL',
    'SYSTEM',
    'MARKETING',
]);
export const NotificationStatusSchema = z.enum(['QUEUED', 'COMPLETED']);
export const DeliveryStatusSchema = z.enum([
    'PENDING',
    'DISPATCHED',
    'DELIVERED',
    'BOUNCED',
    'COMPLAINED',
    'SUPPRESSED',
    'FAILED',
]);
// ─────────────────────────────────────────────────────────────────────────────
// Read shapes
// ─────────────────────────────────────────────────────────────────────────────
/** Template registry row — operator-editable copy. The TS-side template
 *  contract (codeName / payloadSchema / allowedChannels) lives in
 *  apps/backend/src/notifications/templates/. */
export const NotificationTemplateShape = z.object({
    id: z.string().uuid(),
    codeName: z.string(),
    subject: z.string(),
    bodyHtml: z.string(),
    bodyText: z.string(),
    category: NotificationCategorySchema,
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
/** One channel × notification fan-out outcome. Per 13a-1, the detailed
 *  lifecycle lives here; Notification.status only summarises whether
 *  any delivery is still in-flight. */
export const NotificationDeliveryShape = z.object({
    id: z.string().uuid(),
    notificationId: z.string().uuid(),
    channel: NotificationChannelSchema,
    status: DeliveryStatusSchema,
    providerMessageId: z.string().nullable(),
    attemptCount: z.number().int().min(0),
    lastErrorMessage: z.string().nullable(),
    dispatchedAt: z.string().datetime().nullable(),
    deliveredAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
/** Header + payload snapshot + the deliveries fan-out. */
export const NotificationShape = z.object({
    id: z.string().uuid(),
    sourceEventId: z.string().uuid(),
    templateCodeName: z.string(),
    recipientUserId: z.string().uuid().nullable(),
    recipientEmail: z.string().email(),
    /** Snapshot of audit_event.payload per 13a-5 — pure JSON, no FK lookups. */
    payload: z.record(z.string(), z.unknown()),
    status: NotificationStatusSchema,
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    deliveries: z.array(NotificationDeliveryShape),
});
//# sourceMappingURL=notification.schema.js.map